import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_3: FaireProductEntity = {
  token: "nyc-acc-3",
  type: "product",
  name: "Hudson Valley Linen Napkins",
  brandName: "Upstate Linens",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b7746c7895e9df53367707abb3ea17d30f14e7ff3e4a137837f0c2d1e749ca10.webp",
  priceDollars: 25,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/b7746c7895e9df53367707abb3ea17d30f14e7ff3e4a137837f0c2d1e749ca10.webp",
  weight: 0.6,
  dimensions: {
    width: 5,
    height: 5,
    depth: 1,
  },
  description: "Premium linen napkins from Hudson Valley",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "linen", "handmade"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
